import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ChristmasBanner = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-highlight/10 to-primary/10 border-y border-highlight/20">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Sparkles className="w-6 h-6 text-highlight animate-pulse" />
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold text-foreground">
                🎄 URAs Especiais de Natal e Ano Novo
              </p>
              <p className="text-xs text-muted-foreground">
                Surpreenda seus clientes com mensagens festivas humanizadas
              </p>
            </div>
          </div>
          <Button 
            variant="highlight" 
            size="sm"
            asChild
            className="flex-shrink-0"
          >
            <a href="/uras-natal">
              Ver URAs Temáticas
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};
